import { render, staticRenderFns } from "./SettingsWidget.vue?vue&type=template&id=189dc5af&scoped=true"
import script from "./SettingsWidget.vue?vue&type=script&lang=js"
export * from "./SettingsWidget.vue?vue&type=script&lang=js"
import style0 from "./SettingsWidget.vue?vue&type=style&index=0&id=189dc5af&prod&lang=scss"
import style1 from "./SettingsWidget.vue?vue&type=style&index=1&id=189dc5af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189dc5af",
  null
  
)

export default component.exports